import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateRangeValidator(startDateControlName: string, endDateControlName: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const startDateControl = formGroup.get(startDateControlName);
        const endDateControl = formGroup.get(endDateControlName);

        if (!startDateControl || !endDateControl) {
            return null;  // Return null if controls are not present
        }

        const startDate = startDateControl.value;
        const endDate = endDateControl.value;

        // If the end date is not later than the start date, set the error on the end date control
        if (startDate && endDate && new Date(endDate) <= new Date(startDate)) {
            endDateControl.setErrors({ invalidDateRange: true });
        } else {
            endDateControl.setErrors(null);  // Clear the error if the dates are valid
        }

        return null;  // Return null as this validator operates on individual controls
    };
}